import { getTenant } from "../helpers/getTenant"
import { supabase } from "../lib/supabase"
import { getUserId } from "../helpers/getUserId"
import { KINDS } from "../lib/constants"

type PostLikePayload = {
  liked: boolean
  postId: string
}

export const postLike = async ({
  postId,
  liked
}: PostLikePayload): Promise<void> => {
  const userId = await getUserId()

  if (!userId) return

  const record = {
    kind: KINDS.POST_LIKE,
    tenant: getTenant(),
    user_uuid: userId,
    parent_id: postId
  }

  if (liked) {
    return supabase
      .from("db")
      .delete()
      .eq("kind", KINDS.POST_LIKE)
      .eq("parent_id", postId)
      .eq("user_uuid", userId) as unknown as void
  } else {
    return supabase.from("db").insert(record) as unknown as void
  }
}
